module.exports = __webpack_public_path__ + "static/media/afl.340c87bb.svg";